import { SupportFeedCommentDto } from '@api/ChallengeClient';

export interface CommentState {
    expanded: boolean;
    hasMore: boolean;
    items: SupportFeedCommentDto[];
    loaded: boolean;
    loading: boolean;
    loadingMore: boolean;
    next?: string;
}

export type CommentStateMap = Record<string, CommentState>;

export type CommentAction =
    | { type: 'RESET' }
    | { type: 'TOGGLE_EXPANDED'; activityId: string }
    | { type: 'LOAD_START'; activityId: string }
    | { type: 'LOAD_MORE_START'; activityId: string }
    | {
          type: 'LOAD_SUCCESS';
          activityId: string;
          items: SupportFeedCommentDto[];
          hasMore: boolean;
          next?: string;
          append: boolean;
      }
    | { type: 'LOAD_ERROR'; activityId: string };

const DEFAULT_STATE: CommentState = {
    expanded: false,
    hasMore: false,
    items: [],
    loaded: false,
    loading: false,
    loadingMore: false
};

export function commentStateReducer(
    state: CommentStateMap,
    action: CommentAction
): CommentStateMap {
    switch (action.type) {
        case 'RESET':
            return {};

        case 'TOGGLE_EXPANDED': {
            const current = state[action.activityId] ?? DEFAULT_STATE;
            return {
                ...state,
                [action.activityId]: {
                    ...current,
                    expanded: !current.expanded
                }
            };
        }

        case 'LOAD_START': {
            return {
                ...state,
                [action.activityId]: {
                    ...(state[action.activityId] ?? DEFAULT_STATE),
                    expanded: true,
                    loading: true,
                    loadingMore: false,
                    items: []
                }
            };
        }

        case 'LOAD_MORE_START': {
            const current = state[action.activityId] ?? DEFAULT_STATE;
            return {
                ...state,
                [action.activityId]: {
                    ...current,
                    loadingMore: true
                }
            };
        }

        case 'LOAD_SUCCESS': {
            const current = state[action.activityId] ?? DEFAULT_STATE;
            return {
                ...state,
                [action.activityId]: {
                    expanded: true,
                    hasMore: action.hasMore,
                    items: action.append
                        ? [...current.items, ...action.items]
                        : action.items,
                    loaded: true,
                    loading: false,
                    loadingMore: false,
                    next: action.next
                }
            };
        }

        case 'LOAD_ERROR': {
            const current = state[action.activityId] ?? DEFAULT_STATE;
            return {
                ...state,
                [action.activityId]: {
                    ...current,
                    loading: false,
                    loadingMore: false
                }
            };
        }
    }
}
